import { Ordine } from "./../../environments/global";
import { Component, OnInit, ComponentFactoryResolver } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from "@angular/common";

import { NzMessageService } from "ng-zorro-antd";
import { HttpErrorResponse } from "@angular/common/http";

import { GlobalComponent, Result, UserData } from "../../environments/global";

@Component({
  selector: "app-data",
  templateUrl: "insert.component.html",
  styleUrls: ["insert.component.scss"],
  providers: [DatePipe],
})
export class InsertComponent implements OnInit {
  // TABLE VARS
  public dataSet = [];
  public backupSet = [];

  public dateH: Date;
  public totH;
  public sumH = 0;

  // COMPONENT VARS
  public isLoading: boolean = true;
  public trackTitle: string = "";
  public prizeFilter: boolean = false;

  public totStimato: number = 0;
  public totLavorato: number = 0;

  // ################################################
  // CLASS: CONSTRUCTOR
  public constructor(
    public router: Router,
    private route: ActivatedRoute,
    public g: GlobalComponent,
    private datepipe: DatePipe,
    private message: NzMessageService
  ) {}
  // ################################################
  // CLASS: ON INIT
  ngOnInit() {
    if (!this.g.checkUserData()) {
      this.router.navigateByUrl("/track/(trackContent:utente)");
    }

    // SETUP TITLE
    this.trackTitle = this.g.userData.name + " " + this.g.userData.surname;

    this.init();
  }
  // ################################################
  // FUNCTION: INIT
  init() {
    if (this.g.userData.times.length <= 0) {
      this.router.navigateByUrl("/track/(trackContent:utente)");
      return;
    }
    // LOAD DATA
    this.loadData();

    this.dateH = new Date(this.g.userData.times[0].time);
    this.totH = this.g.roundToHalfDown(this.g.userData.times[0].totH);

    // console.log("USERDATA", this.g.userData);
  }
  // ################################################
  // FUNCTION: LOAD DATA
  loadData() {
    this.isLoading = true;
    const query: string =
      'SELECT * from chk_orders WHERE `company`="' +
      this.g.userData.company +
      '" and `status` = true';
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        this.dataSet = res.data;
        this.dataSet.forEach((d) => {
          d["h"] = 0.0;
          if (d.prize) {
            this.calcH(d.id);
          }
          if (d.prize) {
            this.totStimato += d.forecast;
            this.totLavorato += d.total;
          }
        });
        this.backupSet = this.dataSet;
        this.sumH = this.dataSet.reduce(function (prev, cur) {
          return prev + cur.h;
        }, 0);
        console.log("SUMH", this.sumH, this.totH);
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.message.error(
          "Si è vericato un errore non previsto:<br>" + error.statusText,
          { nzDuration: 5000 }
        );
      }
    );
  }
  filterData() {
    if (this.prizeFilter) {
      this.dataSet = this.backupSet.filter(this.isPrice);
    } else {
      this.dataSet = this.backupSet;
    }
  }
  isPrice(e: Ordine, index, array) {
    return e.prize == true;
  }

  calcH(orderId: string) {
    const query: string =
      "SELECT SUM(chk_times.h) AS h FROM chk_times" +
      " WHERE `orderId`=" +
      orderId;
    this.g.mysql(query).subscribe((res: Result) => {
      const index = this.dataSet.findIndex((item) => item.id === orderId);
      this.dataSet[index].total = res.data[0].h ? res.data[0].h : 0;
    });
  }

  selectRow(id: string) {
    this.router.navigateByUrl("/track/(trackContent:tempo)?orderid=" + id);
  }

  goback() {
    this.g.userData = {} as UserData;
    this.router.navigateByUrl("/track/(trackContent:utente)");
  }
  gocheck() {
    this.router.navigateByUrl("/track/(trackContent:check)");
  }

  saveInsert() {
    if (this.sumH > 0) {
      let query: string =
        "INSERT INTO chk_times (id, date, userId, orderId, h) VALUES";
      let key: string = this.datepipe.transform(new Date(), "yyyyMMddHHmmss");

      this.dataSet.forEach((d) => {
        if (d["h"] > 0) {
          query +=
            "(" +
            key +
            "," +
            '"' +
            this.datepipe.transform(this.dateH, "yyyy-MM-dd") +
            '",' +
            this.g.userData.id +
            "," +
            d.id +
            "," +
            d.h +
            "),";
          let nKey = parseInt(key, 0);
          nKey++;
          key = nKey.toString();
        }
      });
      query = query.substring(0, query.length - 1);

      this.isLoading = true;
      this.g.mysql(query).subscribe((resQuery: Result) => {
        if (!resQuery.error) {
          query =
            "UPDATE chk_rfid set `marked` = 1 WHERE `code` = " +
            '"' +
            this.g.userData.code +
            '" AND `marked` = 0 ' +
            "AND `time_enter` in (" +
            this.g.userData.times[0].enters.join(",") +
            ")";
          this.isLoading = true;
          this.g.mysql(query).subscribe((rfidQuery: Result) => {
            if (!rfidQuery.error) {
              this.g.userData.times.shift();
              this.init();
              this.message.success("Aggiornamento completato con successo", {
                nzDuration: 3000,
              });
            } else {
              this.goback();
              this.message.error("Si è verificato un errore, riprovare", {
                nzDuration: 3000,
              });
            }
          });
        } else {
          this.message.error("Si è verificato un errore, riprovare", {
            nzDuration: 3000,
          });
        }
      });
    } else {
      this.goback();
    }
  }

  setH(code: string, type: string) {
    const obj = this.dataSet.find((d) => d.code === code);
    if (type === "+") {
      obj.h += 0.5;
    } else {
      obj.h -= 0.5;
    }
    this.sumH = this.dataSet.reduce(function (prev, cur) {
      return prev + cur.h;
    }, 0);

    // console.log('TOTH', this.totH, 'SUMH', this.sumH);
  }
}
